import { useTranslation } from "react-i18next";
import PeriodSelect from "./PeriodSelect";
import { PeriodFilter as PeriodFilterType } from "@/modules/projects/types/periodFilter";

interface PeriodFilterProps {
  filter: PeriodFilterType;
}

const PeriodFilter = ({ filter }: PeriodFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 whitespace-nowrap">
      <span className="inline-block text-right min-w-6">
        {t("periodSelect.from")}
      </span>
      <PeriodSelect
        value={filter.fromDate}
        onChange={filter.setFromDate}
        options={filter.options}
        className="w-32"
        disableTo={filter.toDate}
      />{" "}
      <span className="inline-block text-right min-w-6">
        {t("periodSelect.to")}
      </span>
      <PeriodSelect
        value={filter.toDate}
        onChange={filter.setToDate}
        options={filter.options}
        className="w-32"
        disableFrom={filter.fromDate}
      />
    </div>
  );
};

export default PeriodFilter;
